import { Button, Dropdown, Icon, Layout, Text } from '@loadsmart/miranda-react'

import { TrackingMethod, TrackingProvider } from '../../domain/Tracking'
import { ProvidersBadge } from './ProvidersBadge'
import { ProviderCard } from './styles'

type TruckNumberCardContentProps = {
  readonly tractorNumber: string
  readonly onClickEditTruck: () => void
  readonly onClickUnassignTruck: () => void
}

export function TruckNumberCardContent({
  tractorNumber,
  onClickEditTruck,
  onClickUnassignTruck,
}: TruckNumberCardContentProps) {
  return (
    <ProviderCard filled onClick={onClickEditTruck}>
      <Layout.Stack gap="spacing-4" justify="space-between" style={{ height: '100%' }}>
        <Layout.Stack gap="spacing-2">
          <Layout.Group align="center" justify="space-between">
            <ProvidersBadge
              methods={[TrackingMethod.ELD]}
              providers={[TrackingProvider.P44, TrackingProvider.TT]}
            />
            <Dropdown>
              <Button
                aria-label="Truck number dropdown"
                variant="icon-secondary"
                size="small"
                aria-haspopup="true"
                onClick={event => {
                  event.stopPropagation()
                }}
              >
                <Icon name="dots-vertical" size="20px" color="color-primary-60" />
              </Button>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={event => {
                    event.stopPropagation()
                    onClickEditTruck()
                  }}
                >
                  Edit truck
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={event => {
                    event.stopPropagation()
                    onClickUnassignTruck()
                  }}
                >
                  <Text color="color-text-error">Unassign truck</Text>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Layout.Group>
          <Text variant="body-md-bold" color="color-primary-60">
            {tractorNumber}
          </Text>
        </Layout.Stack>

        <Text variant="body-sm" color="color-text-placeholder">
          Location provided via ELD
        </Text>
      </Layout.Stack>
    </ProviderCard>
  )
}
